/* global API_ROOT, MOCK_NEWSLETTER_DEFAULT */

/**
 * SPEC-109: whether the newsletter box starts ticked. The backend decides
 * from the visitor's country (CloudFront-Viewer-Country on the API
 * distribution): ticked everywhere except where a pre-ticked box doesn't
 * count as consent (EU, UK, EEA, CH, CA — D2); unknown country, missing
 * header or any failure means unticked (D3 / NFR-1).
 *
 * Asked once per page load; every surface that shows the box shares the
 * answer, and the account-creation event reports it (FR-6).
 */
export const NEWSLETTER_DEFAULT_PATH = '/newsletter/default/'

export const UNTICKED = Object.freeze({ country: '', defaultTicked: false })
// an answer later than this leaves the box as it is (render flow 4)
export const NEWSLETTER_DEFAULT_TIMEOUT_MS = 3000

let request = null
let answer = null

const normalize = (body) => ({
  country: typeof body?.country === 'string' ? body.country : '',
  defaultTicked: body?.newsletter_default_ticked === true
})

const ask = async () => {
  if (typeof MOCK_NEWSLETTER_DEFAULT !== 'undefined' && MOCK_NEWSLETTER_DEFAULT)
    return { country: 'US', defaultTicked: true }
  const response = await fetch(`${API_ROOT}${NEWSLETTER_DEFAULT_PATH}`, {
    credentials: 'omit',
    headers: { Accept: 'application/json' }
  })
  if (!response.ok) return UNTICKED
  return normalize(await response.json())
}

const withTimeout = (promise, ms) =>
  new Promise((resolve) => {
    const timer = setTimeout(() => resolve(UNTICKED), ms)
    promise.then(
      (value) => {
        clearTimeout(timer)
        resolve(value)
      },
      () => {
        clearTimeout(timer)
        resolve(UNTICKED)
      }
    )
  })

// Resolves { country, defaultTicked }; never rejects, never asks twice per
// page load (one in-memory promise, nothing stored across loads: the
// country can change, e.g. on a VPN)
export const fetchNewsletterDefault = () => {
  if (!request)
    request = withTimeout(ask(), NEWSLETTER_DEFAULT_TIMEOUT_MS).then(
      (result) => {
        answer = result
        return result
      }
    )
  return request
}

// The answer once it has arrived (null before), for the analytics event
export const getNewsletterDefault = () => answer

// tests only
export const resetNewsletterDefault = () => {
  request = null
  answer = null
}
